import { NEW_API_ROUTE_ADMIN_DRILL_DOWN_COST_OBJECT } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { CostObjectReportOriginal, DrillDownParamsOriginal, ListResponse } from './types'

type DDCostObjectResponse = ListResponse<CostObjectReportOriginal>

const IS_NEW_BACKEND_API = true

export const getDrillDownCostObjectsReport = async (params: DrillDownParamsOriginal) => {
  const query = new URLSearchParams({ ...params })

  const categoryResult = await get<DDCostObjectResponse>(
    `${NEW_API_ROUTE_ADMIN_DRILL_DOWN_COST_OBJECT}?${query.toString()}`,
    IS_NEW_BACKEND_API
  )

  return {
    ...categoryResult,
    rows: categoryResult.rows.map(category => ({
      ...category,
      amount: Number(category.amount),
      salaryDeductionAmount: Number(category.salaryDeductionAmount),
    })),
  }
}
